module.exports = __webpack_public_path__ + "static/media/next_white.5c24d72f.svg";